<template>
    <div class="AddCoupon">
        <PageTitle>{{ $t('personal-account.AddCoupon.title') }}</PageTitle>
        <Block
            class="AddCoupon-containerBlock"
        >
            <div class="row AddCoupon-inputContainer">
                <div class=" col col-12">
                    <InputFieldWithLabel
                        v-model="discountCode.value"
                        :label="$t('personal-account.AddCoupon.discountCode')"
                        :isRequired="true"
                        :errorLabel="getError(discountCode.errors)"
                        data-cy="input.discountCode"
                    />
                </div>
            </div>
            <div class=" row">
                <div class="AddCoupon-submitContainer col col-12">
                    <RoundedButton
                        :label="$t('personal-account.AddCoupon.save')"
                        type="reversed"
                        class="AddCoupon-submitButton"
                        data-cy="button.save"
                        @buttonClicked="submit"
                    />
                </div>
            </div>
        </Block>
        <Transition
            name="fade"
            mode="out-in"
        >
            <FullScreenModal
                :showModal="showSuccessModal"
                type="success"
                :contentStyle="{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    height: '100%',
                    paddingBottom: '120px',
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }"
                :contentSlotStyle="{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexGrow: '1',
                    margin: '0 20px',
                }"
            >
                <div class="SuccessModal">
                    <div class="SuccessModal-icon">
                        <span class="f2m-check" />
                    </div>
                    <div
                        class="SuccessModal-message"
                        v-html="$t(`personal-account.addCoupon.success.message`)"
                    />
                </div>
            </FullScreenModal>
        </Transition>
    </div>
</template>

<script>
import Component from 'vue-class-component'
import {required, validate} from "@free2move/vuejs-components/validators.js";
import {
    Block, InputFieldWithLabel, RoundedButton,
} from '@free2move/vuejs-components';

import PageTitle from "@/components/PageTitle.vue";

import Vue from 'vue'
import * as mutationTypes from "@/store/mutation-types";
import * as actionTypes from "@/store/action-types";
import Transition from "@/components/Transition.vue";
import FullScreenModal from "@/components/FullScreenModal.vue";

@Component({
    components: {
        FullScreenModal,
        Block,
        InputFieldWithLabel,
        RoundedButton,
        PageTitle,
        Transition,
    }
})
export default class AddCoupon extends Vue {
    data() {
        return {
            discountCode: {
                value: '',
                validators: [required],
                errors: []
            },
            showSuccessModal: false,
        }
    }
    submit() {
        this.resetErrors();
        validate({
            discountCode: this.discountCode,
        })
            .then(() => {
                this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
                this.$store.dispatch(actionTypes.ADD_COUPON, {
                    data: {
                        discountCode: this.discountCode.value,
                    },
                    callback: ({error}) => {
                        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
                        if (!error) {
                            this.showSuccessModal = true;
                            setTimeout(() => {
                                this.showSuccessModal = false
                                this.$router.push({name: 'personalAccountCoupons'});
                            }, 3000);
                        } else {
                            this.discountCode.errors.push(error.message);
                        }
                    }
                })
            })
            .catch((errors)=>{
                this.discountCode.errors = errors.discountCode;
                // this.address.country.errors = errors.country;
            });
    }
    getError(errors) {
        return errors?.length > 0 ? this.$t('personal-account.addCoupon.error.' + errors[0]) : ''
    }
    resetErrors() {
        this.discountCode.errors = [];
    }
}
</script>

<style lang="scss" scoped>
.AddCoupon{
    &-containerBlock{
        margin-top: 60px;
        max-width: 495px;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: 100%;
        }
    }

    &-inputContainer{
        margin-bottom: 28px;
    }

    &-submitButton{
        width: 100%;
    }
}

</style>
